// one-line engine + licence note in the footer of every AquaFlow PDF report (versions from the audited list)
import OSS from './ossComponents.json';
import { clean } from './exporters';

const ver = (id) => OSS.components.find((c) => c.id === id)?.ver || '';
export const aquaEngineNote = (t) => (t.pdfEngineAqua || '').replace('{epa}', ver('owa-epanet')).replace('{js}', ver('epanet-js'));

export const swmmEngineNote = (t) => (t.pdfEngineSwmm || '').replace('{v}', ver('swmm'));

export function pdfEngineFooter(d, t, note = aquaEngineNote) {
  d.setFont('helvetica', 'normal'); d.setFontSize(6.3); d.setTextColor(120);
  const L = d.splitTextToSize(clean(note(t)), 165);
  d.text(L, 14, 292 - (L.length - 1) * 2.7);
}
